<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="addData">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delDevice(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 width="70%"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="modalBodyStyle"
                 title="设备告警策略"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="2"/>
                <a-col :span="3">
                    序号：
                </a-col>
                <a-col :span="6">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
                <a-col :span="2"/>
                <a-col :span="3">
                    策略组名称：
                </a-col>
                <a-col :span="6">
                    <a-input v-model.trim="form.name"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="2"/>
                <a-col :span="3">
                    描述：
                </a-col>
                <a-col :span="6">
                    <a-input v-model.trim="form.descpt"/>
                </a-col>
                <a-col :span="2"/>
                <a-col :span="3">
                    备注：
                </a-col>
                <a-col :span="6">
                    <a-input v-model.trim="form.remark"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 30px">
                <a-col :span="3">
                    <strong style="font-size: 20px">明细信息</strong>
                </a-col>
                <a-col :span="19"/>
                <a-col :span="2">
                    <a-button style="float: right" type="primary" @click="addLine">
                        新增
                    </a-button>
                </a-col>
            </a-row>
            <a-divider style="margin: 5px 0"/>
            <a-table :columns="columnsChildren"
                     size="small"
                     :scroll="{y:'38vh'}"
                     :data-source="form.tacticsDetails"
                     :pagination="false"
                     rowKey="id">
                <template
                        v-for="col in ['orderNo', 'name', 'key','value','msg']"
                        :slot="col"
                        slot-scope="text, record">
                    <div :key="col">
                        <a-input v-model.trim="record[col]"/>
                    </div>
                </template>
                <template slot="condition" slot-scope="text, record">
                    <my-select-tree :tree-value.sync="record.condition" :data-list="conditionList"/>
                </template>
                <template slot="orderNo" slot-scope="text, record">
                    <a-input-number style="width: 100%" v-model.trim="record.orderNo"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a style="color: red" @click="deleteLine(record)">{{record.isDel==='1'?'已删除':'删除'}}</a>
                </template>
            </a-table>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getDeviceTacticsQueryList, deviceTacticsEditDetail, deviceTacticsDelDetail} from './js/ApiDevice';
    import {getJudge} from '../../config/LookUpCache';
    import {modalBodyStyle} from "../../config/Config"

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '策略组名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
            scopedSlots: {customRender: 'orderNo'},
        },
        {
            title: '策略名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            scopedSlots: {customRender: 'name'},
        },
        {
            title: '键',
            dataIndex: 'key',
            key: 'key',
            ellipsis: true,
            scopedSlots: {customRender: 'key'},
        },
        {
            title: '值',
            dataIndex: 'value',
            key: 'value',
            ellipsis: true,
            scopedSlots: {customRender: 'value'},
        },
        {
            title: '判断条件',
            dataIndex: 'condition',
            key: 'condition',
            ellipsis: true,
            scopedSlots: {customRender: 'condition'},
        },
        {
            title: '告警信息',
            dataIndex: 'msg',
            key: 'msg',
            ellipsis: true,
            scopedSlots: {customRender: 'msg'},
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                modalBodyStyle,
                visible: false,
                delVisible: false,
                conditionList: [],
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    name: '',
                    descpt: '',
                    remark: '',
                    tacticsDetails: [],
                },
            }
        },
        methods: {
            // 新增按钮
            addData() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.form.tacticsDetails.forEach(item=>{
                    item.orderNo = item.orderNo + ''
                });
                deviceTacticsEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            // 删除
            delDevice(row) {
                this.lines = row;
                this.delVisible = true;
            },
            delOk() {
                this.delVisible = false;
                deviceTacticsDelDetail({id: this.lines.id}).then(() => {
                    this.getData();
                });
            },
            cancel() {
                this.delVisible = false;
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getDeviceTacticsQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    name: '',
                    descpt: '',
                    remark: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                this.getData({baseDto: baseDto});
            },
            addLine() {
                this.form.tacticsDetails.push({});
            },
            deleteLine(row) {
                row.isDel = '1';
                let index = this.form.tacticsDetails.findIndex(item => {
                    return item === row
                });
                this.form.tacticsDetails.splice(index, 1)
            },
        },
        created() {
            this.getData();
            getJudge(res => {
                this.conditionList = res;
                this.conditionList.forEach(item => {
                    item.id = item.name
                })
            })
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }
</style>
